<template>
  <el-form-item :class="{ desktop: isDesktop }" label="Filters">
    <el-collapse>
      <el-collapse-item title="Traffic filters" name="geo">
        <TrafficFilters v-model="feed" @update="updateTraffic" />
      </el-collapse-item>

      <el-collapse-item title="Block proxy types" name="limits">
        <BlockedProxyTypes
          v-model="feed.block_proxy_type_ids"
          @update:modelValue="update"
        />
      </el-collapse-item>
    </el-collapse>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import TrafficFilters from '@/components/TrafficFilters.vue'
import BlockedProxyTypes from '@/components/BlockedProxyTypes.vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'FeedFilters',
  components: {
    TrafficFilters,
    BlockedProxyTypes
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const feed = ref()
    feed.value = { ...props.modelValue }

    const { isDesktop } = useResize()

    const update = () => {
      const valueToUpdate = {
        block_proxy_type_ids: feed.value.block_proxy_type_ids
      }
      context.emit('update', valueToUpdate)
    }

    const updateTraffic = (valueToUpdate: any) => {
      context.emit('update', valueToUpdate)
    }

    return {
      isDesktop,
      feed,
      update,
      updateTraffic
    }
  }
})
</script>

<style lang="scss" scoped>
.desktop .el-collapse {
  margin-left: 2em;
}

.el-form-item__content > div {
  vertical-align: top;
}

.domains-wrap {
  width: 100%;
  .el-textarea {
    margin-left: 5px;
    vertical-align: top;
    width: 450px;
  }

  .hint {
    line-height: 1.2;
    color: var(--el-text-color-secondary);
    margin-left: 142px;
  }
}
</style>

<style lang="scss" scoped>
.desktop .el-collapse {
  .el-collapse-item__content {
    .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-form-item__label {
      width: inherit !important;
    }
  }
}
.el-form--inline {
  .el-form-item {
    .el-input,
    .el-cascader,
    .el-select,
    .el-autocomplete {
      width: 200px;
    }
  }
}
</style>
